/* =============================================================
 * import
 * ========================================================== */
import Swiper from 'swiper/bundle';
import {FreeMode, Scrollbar, Autoplay} from 'swiper/modules';
import {mediaQuery} from "../utils/utils";

/* =============================================================
 * function
 * ========================================================== */
const swiperHomeShops = [];
const swiperGalleries = [];

export function homeShopSwiper() {

  const swipeContents = document.querySelectorAll('.home_shop_swiper');

  if (swipeContents.length > 0) {

    swipeContents.forEach((swipeContent, index) => {
      const slidesCount = swipeContent.querySelectorAll('.swiper-slide').length;  // スライドの数を取得

      const initSwiper = () => {
        const swiperInstance = new Swiper(swipeContent, {
          modules: [FreeMode, Scrollbar],
          slidesPerView: "auto", // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
          slidesPerGroup: 1,
          speed: 1200, // スライドアニメーションのスピード（ミリ秒）
          initialSlide: 0, // スライドの開始インデックス番号
          centeredSlides: false,
          loop: false,  // スライドが3つ以上の場合のみループを有効にする
          loopAdditionalSlides: 1,
          grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
          watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
          preventClicks: true, // true: スワイプ中の不要なクリックを無効化
          preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
          freeMode: {
            enabled: true, // true：自由にドラッグ（スワイプ）できるようにする。
            momentum: true, // 有効にすると、スライドを離した後もしばらくの間、スライドが動き続けます
            momentumRatio: 1, // 数字が大きいほど惰性スクロールの距離が伸びる（freeMode: trueとfreeModeMomentum:trueが前提）
            momentumVelocityRatio: 1, // 数字が大きいほど惰性スクロールのスピードが速くなる（freeMode: trueとfreeModeMomentum:trueが前提）
            sticky: false,  // スライド位置へのスナップの有効無効
          },
          scrollbar: {
            el: `.swiper-scrollbar-${index}`, // スクロールバー要素のクラスを動的に設定
            draggable: true,
          },
        });
        swiperHomeShops.push(swiperInstance);
      };

      const destroySwiper = () => {
        if (swiperHomeShops[index] && typeof swiperHomeShops[index].destroy === 'function') {
          swiperHomeShops[index].destroy(true, true);
          swiperHomeShops[index] = null;
        }
      };

      const handleSwiper = () => {
        destroySwiper();

        if (!swiperHomeShops[index]) {
          if ((slidesCount > 2 && mediaQuery() !== 'sp') || (slidesCount > 1 && mediaQuery() === 'sp')) {
            initSwiper();
          }
        }
      };

      // スクロールバー要素を動的に作成
      const scrollbar = document.createElement('div');
      scrollbar.classList.add(`swiper-scrollbar-${index}`, 'swiper-scrollbar');
      swipeContent.appendChild(scrollbar);

      handleSwiper();
    });
  }
}


export function gallerySwiper() {
  const swipeContents = document.querySelectorAll('.gallery_swiper');

  if (swipeContents.length > 0) {
    swipeContents.forEach((swipeContent, index) => {
      const slides = swipeContent.querySelectorAll('.swiper-slide');

      // 各スライドの幅を取得し、スピードを計算
      const slideSpeeds = Array.from(slides).map(slide => {
        const width = slide.offsetWidth;
        return (width / 100); // 基準速度 (100px = 1秒)
      });

      const initSwiper = () => {
        const swiperInstance = new Swiper(swipeContent, {
          modules: [Autoplay],
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          slidesPerView: 'auto',
          loop: true,
          loopedSlides: 2,
          grabCursor: false,
          preventClicks: true,
          preventClicksPropagation: true,
          speed: 5000, // スピードをスライドの合計幅に応じて調整
          on: {
            slideChangeTransitionStart: function() {
              const activeIndex = this.realIndex;
              const slideSpeed = slideSpeeds[activeIndex] * 1000; // 速度をミリ秒に変換
              this.params.speed = slideSpeed; // スライドの速度を設定
              this.update(); // Swiperの設定を更新
            },
          },
        });
        swiperGalleries.push(swiperInstance);
      };

      const destroySwiper = () => {
        if (swiperGalleries[index] && typeof swiperGalleries[index].destroy === 'function') {
          swiperGalleries[index].destroy(true, true);
          swiperGalleries[index] = null;
        }
      };

      const handleSwiper = () => {
        destroySwiper();

        if (!swiperGalleries[index]) {
          if ((slides.length > 3 && mediaQuery() !== 'sp') || (slides.length > 1 && mediaQuery() === 'sp')) {
            initSwiper();
          }
        }
      };

      handleSwiper();
    });
  }
}
